import React, { Fragment } from 'react'
import styled from 'styled-components'
import { array, object, string } from 'prop-types'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import ValidacaoFluxosPagamento from '../components/ValidacaoFluxosPagamento'
import EscolhaBrinde from '../../../components/FluxosPagamento/brindes/EscolhaBrinde'
import InlineLoader from '../../../components/InlineLoader/InlineLoader'
import { TITULO_ESCOLHA_BRINDE, DESCRICAO_ESCOLHA_BRINDE } from '../constantsFluxosPagamento'
import { useFluxosPagamento } from '../../../contexts/FluxosPagamentoContext'

const Texto = styled.p`
  ${StyleGuide.tipografia.textoDefault}
  margin-bottom: 2px;

  &:last-of-type {
    margin: 2px 0 15px;
  }

  @media (max-width: ${StyleGuide.mediaQuery.tablet}){
    &:last-of-type {
      margin-bottom: 32px;
    }
  }
`

const Titulo = styled.h3`
  ${StyleGuide.tipografia.titulo3}
  ${StyleGuide.boldFonte}
`

const Brindes = ( { brindesFluxo, etapaAtual, primeiraEtapa } ) => {
  const { temaFluxo } = useFluxosPagamento()

  return (
    <ValidacaoFluxosPagamento
      etapaAtual={ etapaAtual }
      primeiraEtapa={ primeiraEtapa }
    >
      {
        brindesFluxo && brindesFluxo.length ?
          <Fragment>
            <Titulo>
              { TITULO_ESCOLHA_BRINDE }
            </Titulo>
            <Texto>
              { DESCRICAO_ESCOLHA_BRINDE }
            </Texto>
            <EscolhaBrinde
              brindes={ brindesFluxo }
              etapaAtual={ etapaAtual }
            />
          </Fragment> :
          <InlineLoader
            cor={ temaFluxo }
            isCenter
          />
      }
    </ValidacaoFluxosPagamento>
  )
}

Brindes.propTypes = {
  'brindesFluxo': array.isRequired,
  'etapaAtual': object.isRequired,
  'primeiraEtapa': string.isRequired
}

export default Brindes
